import { defineComponent as _defineComponent } from 'vue'
import { IEventEdit } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPaymentSystem',
  props: {
    eventData: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})